import { ConfirmModal } from '@base-app';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DeactivateMemberModalProps } from './DeactivateMemberModal.types';

const DeactivateMemberModal: FC<DeactivateMemberModalProps> = ({ onCancel, onConfirm, show, selectedUserId }) => {
  const { t } = useTranslation(['teams', 'common']);
  return (
    <ConfirmModal
      cancelAction={{
        onClick: onCancel,
        text: t('modal_cancel', { ns: 'common' }),
      }}
      data={selectedUserId}
      confirmAction={{
        onClick: onConfirm,
        text: t('deactivate_modal_confirmation'),
      }}
      show={show}
      title={t('deactivate_modal_title')}
    />
  );
};

export default DeactivateMemberModal;
